export class Logger {
    constructor(opts = {}) {
        this.defaultOptions = {
            prefix: "[@devforce/trailhead-client-logger]: ",
        };
        this.options = this.defaultOptions;
        this.options = {
            ...this.defaultOptions,
            ...opts,
        };
    }
    info(msg, ...args) {
        console.info(`${this.options.prefix}${msg}`.trim(), ...args);
    }
    warn(msg, ...args) {
        console.warn(`${this.options.prefix}${msg}`.trim(), ...args);
    }
    error(msg, ...args) {
        console.error(`${this.options.prefix}${msg}`.trim(), ...args);
    }
}
export const logger = new Logger();
